import Model from './model'

class Section extends Model({
  name: undefined,
  order: undefined,
  assignments: undefined,
}) {}

export { Section as default }
